import React from 'react';
import { PsPage } from '../../shared/components/ps-page/PsPage';
import { I18nUtils } from '../../../i18n/I18nUtils';
import SchemeDocumentsCard from '../components/SchemeDocumentsCard';
import { SchemeDocumentsCreateFormCard } from '../components/SchemeDocumentsFormCard';
import { BreadcrumbsManagerInstance } from '../../shared/breadcrumbs/BreadcrumbsManager';
import { Breadcrumbs } from '../../shared/breadcrumbs/Breadcrumbs';

export default class SchemesScreen extends React.Component {

    constructor(props) {
        super(props);

        BreadcrumbsManagerInstance.build([
            Breadcrumbs.MY_OUTSOURCES,
            Breadcrumbs.MY_OUTSOURCES_DOCUMENTS,
            Breadcrumbs.MY_OUTSOURCES_DOCUMENTS_SCHEMES,
        ]);

        this.state = {
            breadcrumbs: BreadcrumbsManagerInstance.breadcrumbs(),
        };
    }

    render() {
        const { breadcrumbs } = this.state;

        return (
            <PsPage title={I18nUtils.tr('TR_MIS_ESQUEMAS_DE_DOCUMENTOS')} breadcrumbs={breadcrumbs}>
                <SchemeDocumentsCreateFormCard/>
                <SchemeDocumentsCard/>
            </PsPage>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/documents/screens/SchemesScreen.js